import { pages, subPackages, tabBar } from '@/pages.json'
import { isMp } from './platform'
import { getMobileByCode, getOpenIdByCode } from '@/service/index'

const getLastPage = () => {
  // getCurrentPages() 至少有1个元素，所以不再额外判断
  // const lastPage = getCurrentPages().at(-1)
  // 上面那个在低版本安卓中打包回报错，所以改用下面这个【虽然我加了src/interceptions/prototype.ts，但依然报错】
  const pages = getCurrentPages()
  return pages[pages.length - 1]
}

/** 判断当前页面是否是tabbar页  */
export const getIsTabbar = () => {
  if (!tabBar) {
    return false
  }
  if (!tabBar.list.length) {
    // 通常有tabBar的话，list不能有空，且至少有2个元素，这里其实不用处理
    return false
  }
  const lastPage = getLastPage()
  const currPath = lastPage.route
  return !!tabBar.list.find((e) => e.pagePath === currPath)
}

/**
 * 获取当前页面路由的 path 路径和 redirectPath 路径
 * path 如 ‘/pages/login/index’
 * redirectPath 如 ‘/pages/demo/base/route-interceptor’
 */
export const currRoute = () => {
  const lastPage = getLastPage()
  const currRoute = (lastPage as any).$page
  // console.log('lastPage.$page:', currRoute)
  // console.log('lastPage.$page.fullpath:', currRoute.fullPath)
  // console.log('lastPage.$page.options:', currRoute.options)
  // console.log('lastPage.options:', (lastPage as any).options)
  // 经过多端测试，只有 fullPath 靠谱，其他都不靠谱
  const { fullPath } = currRoute as { fullPath: string }
  // console.log(fullPath)
  // eg: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor (小程序)
  // eg: /pages/login/index?redirect=%2Fpages%2Froute-interceptor%2Findex%3Fname%3Dfeige%26age%3D30(h5)
  return getUrlObj(fullPath)
}

const ensureDecodeURIComponent = (url: string) => {
  if (url.startsWith('%')) {
    return ensureDecodeURIComponent(decodeURIComponent(url))
  }
  return url
}
/**
 * 解析 url 得到 path 和 query
 * 比如输入url: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor
 * 输出: {path: /pages/login/index, query: {redirect: /pages/demo/base/route-interceptor}}
 */
export const getUrlObj = (url: string) => {
  const [path, queryStr] = url.split('?')
  // console.log(path, queryStr)

  if (!queryStr) {
    return {
      path,
      query: {},
    }
  }
  const query: Record<string, string> = {}
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    // console.log(key, value)
    query[key] = ensureDecodeURIComponent(value) // 这里需要统一 decodeURIComponent 一下，可以兼容h5和微信y
  })
  return { path, query }
}
/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 这里设计得通用一点，可以传递key作为判断依据，默认是 needLogin, 与 route-block 配对使用
 * 如果没有传 key，则表示所有的pages，如果传递了 key, 则表示通过 key 过滤
 */
export const getAllPages = (key = 'needLogin') => {
  // 这里处理主包
  const mainPages = [
    ...pages
      .filter((page) => !key || page[key])
      .map((page) => ({
        ...page,
        path: `/${page.path}`,
      })),
  ]
  // 这里处理分包
  const subPages: any[] = []
  subPackages.forEach((subPageObj) => {
    // console.log(subPageObj)
    const { root } = subPageObj

    subPageObj.pages
      .filter((page) => !key || page[key])
      .forEach((page: { path: string } & Record<string, any>) => {
        subPages.push({
          ...page,
          path: `/${root}/${page.path}`,
        })
      })
  })
  const result = [...mainPages, ...subPages]
  // console.log(`getAllPages by ${key} result: `, result)
  return result
}

/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNeedLoginPages = (): string[] => getAllPages('needLogin').map((page) => page.path)

/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 只得到 path 数组
 */
export const needLoginPages: string[] = getAllPages('needLogin').map((page) => page.path)

/**
 * 根据微信小程序当前环境，判断应该获取的BaseUrl
 */
export const getEvnBaseUrl = () => {
  const meta = import.meta.env
  console.log(meta, 'meta')
  // 请求基准地址
  let baseUrl =
    meta.VITE_APP_PROXY == 'true' ? meta.VITE_APP_PROXY_PREFIX : meta.VITE_SERVER_BASEURL

  // 小程序端环境区分
  if (isMp) {
    const {
      miniProgram: { envVersion },
    } = uni.getAccountInfoSync()

    switch (envVersion) {
      case 'develop':
        baseUrl = 'https://ukw0y1.laf.run'
        break
      case 'trial':
        baseUrl = 'https://ukw0y1.laf.run'
        break
      case 'release':
        baseUrl = 'https://ukw0y1.laf.run'
        break
    }
  }

  return baseUrl
}

/**
 * 根据微信小程序当前环境，判断应该获取的UPLOAD_BASEURL
 */
export const getEvnBaseUploadUrl = () => {
  // 请求基准地址
  let baseUploadUrl = import.meta.env.VITE_UPLOAD_BASEURL

  // 小程序端环境区分
  if (isMp) {
    const {
      miniProgram: { envVersion },
    } = uni.getAccountInfoSync()

    switch (envVersion) {
      case 'develop':
        baseUploadUrl = 'https://ukw0y1.laf.run/upload'
        break
      case 'trial':
        baseUploadUrl = 'https://ukw0y1.laf.run/upload'
        break
      case 'release':
        baseUploadUrl = 'https://ukw0y1.laf.run/upload'
        break
    }
  }

  return baseUploadUrl
}
export function getCurrentFormattedDateTime() {
  const now = new Date()
  const year = now.getFullYear()
  const month = (now.getMonth() + 1).toString().padStart(2, '0') // 月份从0开始计数
  const day = now.getDate().toString().padStart(2, '0')
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}`
}
export async function getOpenId() {
  const openId = uni.getStorageSync('openId')
  if (!openId) {
    const code = getWXCode()
    if (code && code != '暂无code') {
      const res = await getOpenIdByCode({ code })
      const openId = res.data
      uni.setStorageSync('openId', openId)
      return openId
    } else {
      return ''
    }
  } else {
    return openId
  }
}

export async function getMobile() {
  const mobile = uni.getStorageSync('mobile')
  if (!mobile) {
    const code = getQYWXCode()
    if (code && code != '暂无code') {
      const res = await getMobileByCode({ code })
	  if(res.code!=200){
		  console.log(res.msg)
		  return ''
	  }
      const mobile = res.data.employeePhone
      uni.setStorageSync('mobile', mobile)
      return mobile
    } else {
      return ''
    }
  } else {
    return mobile
  }
}

export function getUrlParams() {
  const url = location.search
  const theRequest = {
    code: '',
  }
  if (url.indexOf('?') != -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
    }
  }
  console.log(theRequest)
  return theRequest
}
// 截取code方法
function getCode() {
  // 截取url中的code方法
  const url = location.search
  const theRequest = {
    code: '',
  }
  if (url.indexOf('?') != -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
    }
  }
  // const code = theRequest.code || uni.getStorageSync('code')
  const code = theRequest.code
  return code
}

// 获取code并登录
export function getWXCode() {
  const meta = import.meta.env
  const appid = meta.VITE_WX_APPID // 公众号的唯一标识
  const code = getCode() // 是否存在code
  const url = window.location.href
  if (code == null || code === '') {
    const location =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
      appid +
      '&redirect_uri=' +
      encodeURIComponent(url) +
      '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
    window.location.href = location
    return '暂无code'
  } else {
    return code
    // 此处调用后端提供的接口，传入获取到的code换取access_token
  }
}

// 获取企业微信的code并登录
export function getQYWXCode() {
  const meta = import.meta.env
  const appid = meta.VITE_QYWX_APPID // 企业的id,即企业的CorpID
  const code = getCode() // 是否存在code
  const url = window.location.href
  if (code == null || code === '') {
	const location =
	  'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + 
	  appid + 
	  '&redirect_uri=' + 
	  encodeURIComponent(url) + 
	  '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
	  //'&response_type=code&scope=snsapi_base&state=STATE&agentid=AGENTID#wechat_redirect'
    window.location.href = location
    return '暂无code'
  } else {
    return code
    // 此处调用后端提供的接口，传入获取到的code换取access_token
  }
}

export const isWeChat = () => {
  const ua = navigator.userAgent.toLowerCase()
  const isWXWork = ua.match(/wxwork/i) == 'wxwork'
  const isWeXin = !isWXWork && ua.match(/MicroMessenger/i) == 'micromessenger'
  return isWeXin
}
export const isMobile = (phoneNumber: string): boolean => {
  const regex = /^1[3-9]\d{9}$/
  return regex.test(phoneNumber)
}
export function isEmail(str) {
  const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
  return emailRegex.test(str)
}
export const encryptPhone = (phoneNumber: string): string => {
  if (!phoneNumber) return ''
  if (phoneNumber.includes('*')) return phoneNumber
  return phoneNumber.slice(0, 3) + '****' + phoneNumber.slice(7)
}
